import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'form-file',
  templateUrl: './file.component.html'
})
export class FileComponent implements OnInit {
  @Input() icon = 'outbox';
  @Input() name: string;
  @Input() label: string;
  @Input() required = false;
  @Input() disabled = false;
  @Input() multiple = false;
  @Input() accept: string;

  @Output() changeFileInputEvent = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  changeFileInput(event) {
    if (event.target.value) {
      this.changeFileInputEvent.emit(event);
    }
  }
}
